export default __webpack_public_path__ + "static/media/BlurredImage.96c70f12.png";